import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(()=>({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
  },
  input:{
    border: 'none',
    height: 40,
    width: '100%',
  }
}));

export default useStyles;
